import { DetailFilters } from 'src/features/monitoringDashboardAlpha/detail/hooks/useDetailFilters'

// 検証用機能のため共有の queryKeyPrefix には登録せず、ローカルで完結させる
const prefix = ['ui:monitoringDashboard:detail'] as const

export const queryKeys = {
  dashboardReportDetails: (filters: DetailFilters) => [
    ...prefix,
    'dashboardReportDetails',
    filters,
  ],
}
